import React, { FC, useContext, useState } from 'react'
import PartnerCard from "@pages/partners/components/partnerCard/PartnerCard";
import st from './partnersPage.module.scss';
import dictionaryImg from "@assets/images/partners/dictionary-card.png";
import trueFieldsImg from "@assets/images/partners/true-fields-card.png"
import droneImg from "@assets/images/partners/drone-card.png"
import uralchemImg from "@assets/images/partners/uralchem-card.png"
import DronesForm from "@pages/partners/items/drones/form/Form";
import UralchemForm from "@pages/partners/items/uralchem/form/Form";
import { ApiContext } from "@context/ApiContext";
import { withLayout } from "@pages/dashboard/DashboardPage";
import HeaderDashboardLayout from "@layouts/headerDashboardLayout/HeaderDashboardLayout";
import Tx from "@baseTypes/naming";
import { Width } from "@baseTypes/baseType";

const PartnersPage: FC<any> = () => {

    const api = useContext(ApiContext);

    const [isDronesOrderVisible, setDronesOrderVisible] = useState(false);
    const [isUralchemOrderVisible, setUralchemOrderVisible] = useState(false);

    const partners = [
        {
            headerText: 'Справочник агронома',
            imgSrc: dictionaryImg,
            description: 'Структурированная по видам культур справочная информация о вредителях, сорняках и болезнях с изображениями и описанием.',
            orderButton: () => {api!.eventApi.orderbtnclick({})},
            visibility: true,
        },
        {
            headerText: 'True Fields',
            imgSrc: trueFieldsImg,
            description: 'Программный комплекс с искусственным интеллектом, который помогает повышать урожайность культур путём точного внесения материала на основе достоверных данных о потенциале плодородия полей.',
            orderButton: () => {window.open('https://agronote.ru/truefields/', '_blank')},
            visibility: true,
        },
        {
            headerText: 'ООО Консорциум БАС',
            imgSrc: droneImg,
            description: 'Обработка полей с применением дронов по технологии малообъемного опрыскивания.',
            detailsButtonRoute: 'drones',
            orderButton: () => {setDronesOrderVisible(true)},
            visibility: (process.env.DRONES_URL || "https://fly.mikhailichenko.ru/api/fly_request" ) != "",
        },
        {
            headerText: 'Агролаборатория',
            imgSrc: uralchemImg,
            description: 'Быстрый и качественный анализ почвы и грунтов, зеленой массы растений и кормов, а также поливных вод и органических удобрений.',
            detailsButtonRoute: 'uralchem',
            orderButton: () => {setUralchemOrderVisible(true)},
            visibility: true,
        },
    ]

    return (
            <HeaderDashboardLayout
                cropVisible={false}
                goBackButtonVisible={false}
                title={Tx.Partners}
                contentContainerWidth={Width.Auto}
            >
                <div className={st['partners']}>
                    <ul className={st['partners__list']}>
                        {partners.filter(({visibility}) => Boolean(visibility)).map((partner) => <PartnerCard {...partner} />)}
                    </ul>
                </div>
                {isDronesOrderVisible && <DronesForm hideWindow={() => setDronesOrderVisible(false)}/>}
                {isUralchemOrderVisible && <UralchemForm hideWindow={() => setUralchemOrderVisible(false)}/>}
            </HeaderDashboardLayout>
    )
}

export default withLayout(PartnersPage);